




































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
// import SeismicForm from '@/models/SeismicForm'

export default Vue.extend({
  name: 'SpecificPoints',

  props: {
    value: { type: Array },
    specificPoints: { type: Array, default: () => [] },
    section: { type: String }
  },
  data: () => {
    return {
      internalList: [] as undefined | Array<SpecificPoint>,
      selectedType: 'réserve' as string,
      selectedElement: '' as string,
      selectedProblem: '' as string
    }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode']),
    sectionSpecificPoints () {
      return this.specificPoints.filter(point => (point as SpecificPoint).section === this.section)
    }
  },
  created () {
    this.internalList = this.value as SpecificPoint[]
  },
  methods: {
    addPoint (): void {
      const point: SpecificPoint = {
        refPhoto: '',
        section: this.section,
        type: this.selectedType,
        element: this.selectedElement,
        problem: this.selectedProblem
      }
      // this.specificPoints = this.specificPoints?.filter(item => item !== 'SO')
      // eslint-disable-next-line no-unused-expressions
      // this.internalList?.push(point)
      // eslint-disable-next-line no-unused-expressions
      this.specificPoints.push(point)
      this.selectedElement = ''
      this.selectedProblem = ''
    },

    setSO () {
      const point: SpecificPoint = {
        refPhoto: '',
        section: this.section,
        type: '',
        element: 'SO',
        problem: ''
      }
      // eslint-disable-next-line no-unused-expressions
      this.specificPoints?.push(point)

      // this.specificPoints?.splice(0, this.specificPoints?.length, 'SO')
    },
    remove (point: SpecificPoint) {
      console.log('COUCOU', point)
      for (let i = 0; i < this.specificPoints.length; i++) {
        const currentPoint = this.specificPoints[i]
        if ((currentPoint as SpecificPoint).section === point.section &&
            (currentPoint as SpecificPoint).refPhoto === point.refPhoto &&
            (currentPoint as SpecificPoint).element === point.element &&
            (currentPoint as SpecificPoint).problem === point.problem
        ) {
          // eslint-disable-next-line no-unused-expressions
          this.specificPoints?.splice(i, 1)
        }
      }
    }
  }
})

export type SpecificPoint = {
  type: string
  refPhoto: string
  element: string
  problem: string
  section: string // Sections are used to identify current form page (to display only current points)
}

